/* Keep Judge.me reviews aligned with the Strive interaction system. */
(() => {
  const reviewRootSelector = '#judgeme_product_reviews';
  const featuredCarouselSelector = '.jdgm-carousel-wrapper';
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let queued = false;

  // Full review reading is independent of the fixed-height carousel card.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('button, a, .jm-review-content__body--clickable');
    const card = trigger?.closest('.jm-review-item, .jdgm-carousel-item');
    if (!card || (!/^(Más|Leer completa)$/i.test(trigger.textContent.trim()) && !trigger.matches('.jm-review-content__body--clickable'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    let dialog = document.querySelector('.strive-review-dialog');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'strive-review-dialog';
      dialog.innerHTML = '<button type="button" aria-label="Cerrar reseña">Cerrar ×</button><h2 id="strive-review-dialog-title">Reseña completa</h2><p class="strive-dialog-author"></p><div class="strive-dialog-body"></div>';
      dialog.setAttribute('aria-labelledby','strive-review-dialog-title');
      document.body.append(dialog);
      dialog.querySelector('button').onclick = () => dialog.close();
      dialog.addEventListener('close', () => dialog.striveTrigger?.focus());
    }
    dialog.striveTrigger = trigger;
    dialog.querySelector('.strive-dialog-author').textContent = card.querySelector('.jm-reviewer-info__name, .jdgm-carousel-item__reviewer-name')?.textContent || '';
    dialog.querySelector('.strive-dialog-body').textContent = card.querySelector('.jm-review-content__body, .jdgm-carousel-item__review-body')?.textContent || '';
    dialog.showModal();
  }, true);

  function prepareAllReviews(carousel) {
    if (carousel.dataset.striveAllReady) return;
    const track = carousel.querySelector('.jdgm-carousel__item-wrapper');
    const viewport = carousel.querySelector('.jdgm-carousel__item-container');
    if (!track || !viewport) return;
    carousel.dataset.striveAllReady = 'true';
    let page = 0, total = Infinity, busy = false;
    const ids = new Set();
    const status = document.createElement('span');
    status.className = 'strive-review-progress';
    status.setAttribute('role', 'status');
    carousel.querySelector('.jdgm-carousel__arrows')?.prepend(status);
    const update = () => { status.textContent = `${Number.isFinite(total) ? total : ids.size} reseñas · Usa las flechas para verlas todas`; };
    const load = async () => {
      if (busy || ids.size >= total) return;
      busy = true;
      status.textContent = 'Cargando reseñas…';
      try {
        const params = new URLSearchParams({widget_type:'all-reviews', page:String(page + 1), per_page:'15', require_json:'true', shop_domain:window.Shopify.shop, platform:'shopify'});
        const response = await fetch(`https://cdn.judge.me/reviews/all_reviews_js_based?${params}`);
        if (!response.ok) throw new Error('Reviews unavailable');
        const data = await response.json();
        const doc = new DOMParser().parseFromString(data.html || '', 'text/html');
        const items = [...doc.querySelectorAll('.jdgm-rev')];
        items.sort((a,b) => {
          const rank = node => (node.querySelector('.jdgm-rev__body')?.textContent.trim() ? 2 : 0) + (!/^(an[oó]nimo|anonymous)$/i.test(node.querySelector('.jdgm-rev__author')?.textContent.trim() || '') ? 1 : 0);
          return rank(b) - rank(a);
        });
        if (!items.length) throw new Error('No further reviews returned');
        if (!page) { track.replaceChildren(); carousel.classList.add('strive-all-reviews'); }
        const reportedTotal = Number(data.number_of_product_reviews || 0) + Number(data.number_of_shop_reviews || 0);
        if (reportedTotal > 0) total = reportedTotal;
        items.forEach(item => {
          const id = item.dataset.reviewId;
          if (!id || ids.has(id)) return;
          ids.add(id);
          const card = document.createElement('article');
          card.className = 'jdgm-carousel-item strive-review-has-body';
          // Judge.me's responsive observer expects a title node, even when it is empty.
          card.innerHTML = '<div class="jdgm-carousel-item__inner-wrapper"><div class="jdgm-carousel-item__review"><div class="jdgm-carousel-item__review-rating"></div><div class="jdgm-carousel-item__review-title"></div><div class="jdgm-carousel-item__review-body"></div><button type="button" class="strive-read-full">Leer completa</button></div><div class="jdgm-carousel-item__reviewer-name"></div></div>';
          const rating = Math.max(0, Math.min(5, Number(item.querySelector('[data-score]')?.dataset.score || 0)));
          const stars = card.querySelector('.jdgm-carousel-item__review-rating');
          stars.classList.add('strive-review-stars');
          stars.textContent = '★'.repeat(rating) + '☆'.repeat(5-rating);
          stars.setAttribute('aria-label',`${rating} de 5 estrellas`);
          const body = item.querySelector('.jdgm-rev__body')?.textContent?.trim() || item.querySelector('.jdgm-rev__title')?.textContent?.trim() || '';
          card.querySelector('.jdgm-carousel-item__review-body').textContent = body || 'Calificación sin comentario';
          if (!body) card.querySelector('.strive-read-full').remove();
          card.querySelector('.jdgm-carousel-item__reviewer-name').textContent = `${item.querySelector('.jdgm-rev__author')?.textContent?.trim() || 'Anónimo'}${item.dataset.verifiedBuyer === 'true' ? ' · Verificado' : ''}`;
          track.append(card);
          const reader = card.querySelector('.strive-read-full');
          const text = card.querySelector('.jdgm-carousel-item__review-body');
          if (reader) new ResizeObserver(() => { reader.hidden = text.scrollHeight <= text.clientHeight + 1; }).observe(text);
        });
        page += 1;
        // The aggregate badge can lag behind newly published reviews.
        total = Math.max(total, ids.size);
        const summaryCount = carousel.querySelector('.strive-review-summary-card__count');
        if (summaryCount) summaryCount.textContent = `${total} reseñas`;
        update();
      } catch (error) { status.textContent = 'No se pudo cargar. Pulsa → para reintentar.'; }
      finally { busy = false; }
    };
    carousel.addEventListener('click', async event => {
      const next = event.target.closest('.jdgm-carousel__right-arrow');
      const prev = event.target.closest('.jdgm-carousel__left-arrow');
      if (!next && !prev) return;
      event.preventDefault(); event.stopImmediatePropagation();
      const amount = track.querySelector('.jdgm-carousel-item')?.getBoundingClientRect().width || 300;
      if (next && viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 4) await load();
      viewport.scrollBy({left:(next ? 1 : -1)*(amount+14),behavior:motionQuery.matches?'auto':'smooth'});
    }, true);
    viewport.addEventListener('scroll', () => {
      if (viewport.scrollLeft > 0 && viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 40) load();
    }, {passive:true});
    load();
  }

  function formatCustomerCount(value) {
    const count = Number(value);
    if (!Number.isFinite(count) || count < 1) return '';
    if (count >= 1000) return `+${Math.floor(count / 1000)}k`;
    return `+${count}`;
  }

  function restoreNativeSort() {
    queued = false;
    document.querySelectorAll(`${reviewRootSelector} .strive-de-chips-wrapper`).forEach((chips) => chips.remove());

    document.querySelectorAll(`${reviewRootSelector} .jdgm-sort-dropdown`).forEach((select) => {
      // The historical customization hides this select inline after it creates seven chips.
      // Keep its processed marker so that customization does not re-run, but restore the control.
      select.style.setProperty('display', 'block', 'important');
      const filter = select.closest('.jm-sort-filter');
      filter?.classList.add('strive-review-sort-ready');
      const label = filter?.querySelector('label');
      if (label) {
        label.textContent = 'Ordenar reseñas';
        label.classList.remove('jdgm-visually-hidden');
        label.classList.add('strive-sort-label');
      }
    });
  }

  // Section Store renders the product-page rating in a shadow root. Treat it as
  // one reusable product affordance: a rounded score and a direct route to reviews.
  function prepareProductRatingLinks() {
    const reviewRoot = document.querySelector(reviewRootSelector);
    if (!reviewRoot) return;

    document.querySelectorAll('section-store--review-summary-block').forEach((summary) => {
      const shadow = summary.shadowRoot;
      const scoreNode = shadow?.querySelector('.metafield-rating');
      const rawScore = scoreNode?.textContent?.trim().replace(',', '.') || '';
      const score = Number.parseFloat(rawScore);
      const roundedScore = Number.isFinite(score) ? score.toFixed(1) : rawScore;

      if (scoreNode && roundedScore) scoreNode.textContent = roundedScore;
      summary.classList.add('strive-product-rating-link');
      summary.setAttribute('role', 'link');
      summary.setAttribute('tabindex', '0');
      summary.setAttribute(
        'aria-label',
        roundedScore ? `Ver reseñas del producto: ${roundedScore} de 5` : 'Ver reseñas del producto',
      );
      summary.title = 'Ver reseñas del producto';

      if (summary.dataset.striveReviewLinkReady === 'true') return;
      summary.dataset.striveReviewLinkReady = 'true';

      const goToReviews = () => {
        const target = document.querySelector(reviewRootSelector);
        if (!target) return;
        const headerOffset = 96;
        const top = window.scrollY + target.getBoundingClientRect().top - headerOffset;
        window.scrollTo({ top, behavior: motionQuery.matches ? 'auto' : 'smooth' });
        target.setAttribute('tabindex', '-1');
        window.setTimeout(() => target.focus({ preventScroll: true }), motionQuery.matches ? 0 : 450);
      };

      summary.addEventListener('click', goToReviews);
      summary.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        goToReviews();
      });
    });
  }

  function prepareProductReviews() {
    document.querySelectorAll(reviewRootSelector).forEach((root) => {
      const list = root.querySelector('.jdgm-review-list');
      let carousel = list?.closest('.strive-product-carousel-layout');
      if (list) {
        const metrics = getProductReviewMetrics(root);
        carousel = prepareProductCarousel(root, list);
        renderProductSummary(carousel, metrics);
        const reviews = [...list.querySelectorAll(':scope > .jm-review-item')];

        reviews.forEach((review) => {
          const hasBody = Boolean(review.querySelector('.jm-review-content__body')?.textContent?.trim());
          review.classList.toggle('strive-review-has-body', hasBody);
        });

        // Empty star-only reviews remain available, but written feedback leads the page.
        reviews
          .map((review, index) => ({
            review,
            index,
            hasWrittenFeedback: Boolean(
              review.querySelector('.jm-review-content__title, .jm-review-content__body')?.textContent?.trim(),
            ),
          }))
          .sort((first, second) => Number(second.hasWrittenFeedback) - Number(first.hasWrittenFeedback) || first.index - second.index)
          .forEach(({ review }, index) => {
            if (list.children[index] !== review) list.insertBefore(review, list.children[index] || null);
          });
      }

      const pagination = root.querySelector('.jm-pagination-controls');
      const nextPage = pagination?.querySelector('[aria-label="Go to next page"]');
      if (!pagination || !nextPage) return;

      let moreButton = root.querySelector('.strive-product-more-reviews');
      if (!moreButton) {
        moreButton = document.createElement('button');
        moreButton.type = 'button';
        moreButton.className = 'strive-product-more-reviews';
        moreButton.textContent = 'Ver más reseñas →';
        moreButton.addEventListener('click', () => {
          root.querySelector('.jm-pagination-controls [aria-label="Go to next page"]')?.click();
        });
        pagination.before(moreButton);
      }

      const hasNextPage = !nextPage.disabled && !nextPage.classList.contains('jm-button--disabled');
      moreButton.hidden = !hasNextPage;
      moreButton.disabled = !hasNextPage;

      // Keep progressive disclosure alongside carousel navigation instead of
      // creating a second, visually empty row beneath the reviews.
      const controls = carousel?.querySelector('.strive-product-carousel-controls');
      if (controls && moreButton.parentElement !== controls) controls.prepend(moreButton);
      if (controls) {
        let progress = controls.querySelector('.strive-review-progress');
        if (!progress) { progress = document.createElement('span'); progress.className = 'strive-review-progress'; progress.setAttribute('role','status'); controls.prepend(progress); }
        const current = pagination.querySelector('[aria-current="page"]')?.textContent.trim() || '1';
        const pages = [...pagination.querySelectorAll('[aria-label^="Go to page "]')].map(e => Number(e.textContent.trim())).filter(Number.isFinite);
        const text = `Página ${current} de ${Math.max(1,...pages)}`;
        if (progress.textContent !== text) progress.textContent = text;
      }
    });
  }

  function getProductReviewMetrics(root) {
    const values = [...root.querySelectorAll('.jm-review-widget-header__average-rating-display .jm-text')]
      .map((node) => node.textContent.trim())
      .filter(Boolean);
    const scoreValue = Number.parseFloat(values.find((value) => /^\d+(?:[.,]\d+)?$/.test(value))?.replace(',', '.') || '');
    const countValue = values.find((value) => /reseñ/i.test(value)) || '';
    const count = Number.parseInt(countValue.replace(/\D/g, ''), 10);

    return {
      score: Number.isFinite(scoreValue) ? scoreValue.toFixed(1) : '—',
      count: Number.isFinite(count) ? count : 0,
    };
  }

  function renderProductSummary(carousel, { score, count }) {
    let summary = carousel.querySelector(':scope > .strive-product-summary-card');
    if (!summary) {
      summary = document.createElement('article');
      summary.className = 'strive-product-summary-card';
      carousel.prepend(summary);
    }

    const reviewLabel = `${count} ${count === 1 ? 'reseña' : 'reseñas'}`;
    const signature = `${score}:${count}`;
    if (summary.dataset.metrics === signature) return;
    summary.dataset.metrics = signature;
    const customerLabel = `${count} ${count === 1 ? 'cliente opinó' : 'clientes opinaron'}`;
    summary.setAttribute('aria-label', `${score} de 5, ${reviewLabel}`);
    summary.innerHTML = `
      <div class="strive-product-summary-card__inner">
        <span class="strive-product-summary-card__stars" aria-hidden="true">★★★★★</span>
        <span class="strive-product-summary-card__score"><strong>${score}</strong><span>puntaje</span></span>
        <span class="strive-product-summary-card__count">${reviewLabel}</span>
        <span class="strive-summary-context">Opiniones sobre este producto</span>
      </div>
    `;
  }

  function prepareProductCarousel(root, list) {
    let carousel = list.closest('.strive-product-carousel-layout');
    if (!carousel) {
      carousel = document.createElement('div');
      carousel.className = 'strive-product-carousel-layout';
      list.before(carousel);
      carousel.append(list);
    }

    let controls = carousel.querySelector('.strive-product-carousel-controls');
    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'strive-product-carousel-controls';
      controls.innerHTML = `
        <button type="button" class="strive-product-carousel-pause" aria-pressed="false" aria-label="Pausar movimiento de reseñas" title="Pausar movimiento">Pausar movimiento</button>
        <button type="button" class="strive-product-carousel-previous" aria-label="Reseñas anteriores">←</button>
        <button type="button" class="strive-product-carousel-next" aria-label="Siguientes reseñas">→</button>
      `;
      carousel.append(controls);
    }

    if (carousel.dataset.striveAutoplayReady === 'true') return carousel;
    carousel.dataset.striveAutoplayReady = 'true';

    const pauseButton = controls.querySelector('.strive-product-carousel-pause');
    const previousButton = controls.querySelector('.strive-product-carousel-previous');
    const nextButton = controls.querySelector('.strive-product-carousel-next');
    let timer;
    let userPaused = false;

    const pause = () => window.clearInterval(timer);
    const step = (direction, manual = false) => {
      const card = list.querySelector('.jm-review-item');
      if (!card) return;
      const amount = card.getBoundingClientRect().width + 14;
      // Desktop arrows select a Judge.me page; swipe and autoplay still scroll
      // individual cards. A five-review batch otherwise only has one card of overflow.
      if (manual && list.clientWidth >= amount * 2) {
        const label = direction > 0 ? 'Go to next page' : 'Go to previous page';
        const pageButton = root.querySelector(`.jm-pagination-controls [aria-label="${label}"]`);
        if (pageButton && !pageButton.disabled && !pageButton.classList.contains('jm-button--disabled')) {
          pageButton.click();
          list.scrollTo({ left: 0, behavior: 'auto' });
        }
        return;
      }
      const maxScroll = list.scrollWidth - list.clientWidth;
      const nextLeft = list.scrollLeft + direction * amount;
      // Scroll snap / list padding can leave a few pixels at either edge.
      const edgeTolerance = Math.max(16, amount * .08);
      const atEnd = direction > 0 && list.scrollLeft >= maxScroll - edgeTolerance;
      const atStart = direction < 0 && list.scrollLeft <= edgeTolerance;
      if (atEnd || atStart) {
        const label = atEnd ? 'Go to next page' : 'Go to previous page';
        const pageButton = root.querySelector(`.jm-pagination-controls [aria-label="${label}"]`);
        if (pageButton && !pageButton.disabled && !pageButton.classList.contains('jm-button--disabled')) {
          pageButton.click();
          list.scrollTo({ left: 0, behavior: 'auto' });
        }
        return;
      }
      list.scrollTo({ left: Math.max(0, Math.min(maxScroll, nextLeft)), behavior: motionQuery.matches ? 'auto' : 'smooth' });
    };
    const play = () => {
      pause();
      if (userPaused || motionQuery.matches || document.hidden) return;
      timer = window.setInterval(() => step(1), 5200);
    };
    const updatePauseButton = () => {
      pauseButton.textContent = userPaused ? 'Reanudar movimiento' : 'Pausar movimiento';
      pauseButton.setAttribute('aria-pressed', String(userPaused));
      pauseButton.setAttribute('aria-label', userPaused ? 'Reanudar movimiento de reseñas' : 'Pausar movimiento de reseñas');
      pauseButton.title = userPaused ? 'Reanudar movimiento' : 'Pausar movimiento';
    };

    previousButton?.addEventListener('click', () => step(-1, true));
    nextButton?.addEventListener('click', () => step(1, true));
    pauseButton?.addEventListener('click', () => {
      userPaused = !userPaused;
      updatePauseButton();
      userPaused ? pause() : play();
    });
    carousel.addEventListener('pointerenter', pause);
    carousel.addEventListener('pointerleave', play);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) play();
    });
    carousel.addEventListener('touchstart', pause, { passive: true });
    carousel.addEventListener('touchend', () => window.setTimeout(play, 5200), { passive: true });
    updatePauseButton();
    play();
    return carousel;
  }

  function prepareFeaturedCarousel(carousel) {
    if (carousel.dataset.striveAutoplayReady === 'true') return;
    carousel.dataset.striveAutoplayReady = 'true';

    const widget = carousel.querySelector('.jdgm-widget.jdgm-carousel');
    const track = carousel.querySelector('.jdgm-carousel__item-wrapper');
    const itemContainer = carousel.querySelector('.jdgm-carousel__item-container');
    const rawScore = carousel.querySelector('.jdgm-all-reviews-rating')?.dataset.score || '';
    const scoreValue = Number.parseFloat(rawScore);
    const score = Number.isFinite(scoreValue) ? scoreValue.toFixed(1) : rawScore;
    const count = carousel.querySelector('.jdgm-carousel-number-of-reviews')?.dataset.numberOfReviews || '';
    const customerCount = formatCustomerCount(window.striveReviewMetrics?.customerCountMinimum);

    // Older preview sessions placed this card in the moving track. Remove it so the summary is fixed.
    track?.querySelector('.strive-review-summary-card')?.remove();

    if (widget && itemContainer && !widget.querySelector(':scope > .strive-review-summary-card')) {
      const summary = document.createElement('div');
      summary.className = 'strive-review-summary-card';
      summary.setAttribute('aria-label', `${score} de 5, ${count} reseñas`);
      summary.innerHTML = `
        <div class="strive-review-summary-card__inner">
          <span class="strive-review-summary-card__stars" aria-hidden="true">★★★★★</span>
          <span class="strive-review-summary-card__score"><strong class="strive-review-summary-card__score-value">${score}</strong><span class="strive-review-summary-card__score-label">puntaje</span></span>
          <span class="strive-review-summary-card__count">${count} reseñas</span>
          ${customerCount ? `<span class="strive-review-summary-card__community"><strong class="strive-review-summary-card__community-value">${customerCount}</strong><span class="strive-review-summary-card__community-label">clientes</span></span>` : ''}
        </div>
      `;
      itemContainer.before(summary);
    }

    const reviews = track
      ? [...track.querySelectorAll(':scope > .jdgm-carousel-item:not(.strive-review-summary-card)')]
      : [];
    const anonymousName = /^(an[oó]nim[oa]|anonymous)$/i;

    // Preserve the original ordering inside each group, but lead with attributable reviews.
    if (track && reviews.length > 1) {
      reviews
        .map((review, index) => ({
          review,
          index,
          anonymous: anonymousName.test(review.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent?.trim() || ''),
        }))
        .sort((first, second) => Number(first.anonymous) - Number(second.anonymous) || first.index - second.index)
        .forEach(({ review }) => track.append(review));
    }

    reviews.forEach((review) => {
      const hasBody = Boolean(review.querySelector('.jdgm-carousel-item__review-body')?.textContent?.trim());
      review.classList.toggle('strive-review-has-body', hasBody);
    });

    let timer;
    let userPaused = false;
    const arrows = carousel.querySelector('.jdgm-carousel__arrows');
    let motionToggle = arrows?.querySelector('.strive-carousel-motion-toggle');
    if (arrows && !motionToggle) {
      motionToggle = document.createElement('button');
      motionToggle.type = 'button';
      motionToggle.className = 'strive-carousel-motion-toggle';
      arrows.prepend(motionToggle);
    }
    const updateMotionToggle = () => {
      if (!motionToggle) return;
      motionToggle.textContent = userPaused ? 'Reanudar movimiento' : 'Pausar movimiento';
      motionToggle.setAttribute('aria-pressed', String(userPaused));
      motionToggle.setAttribute('aria-label', userPaused ? 'Reanudar movimiento de reseñas' : 'Pausar movimiento de reseñas');
      motionToggle.title = userPaused ? 'Reanudar movimiento' : 'Pausar movimiento';
    };
    const pause = () => window.clearInterval(timer);
    const play = () => {
      pause();
      if (userPaused || motionQuery.matches || document.hidden) return;

      timer = window.setInterval(() => {
        carousel.querySelector('.jdgm-carousel__right-arrow')?.click();
      }, 5200);
    };

    motionToggle?.addEventListener('click', () => {
      userPaused = !userPaused;
      updateMotionToggle();
      userPaused ? pause() : play();
    });
    updateMotionToggle();

    // It advances using Judge.me's own slider control, so drag, arrows and analytics keep working.
    carousel.addEventListener('pointerenter', pause);
    carousel.addEventListener('pointerleave', play);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) play();
    });
    carousel.addEventListener('touchstart', pause, { passive: true });
    carousel.addEventListener('touchend', () => window.setTimeout(play, 5200), { passive: true });
    document.addEventListener('visibilitychange', () => (document.hidden ? pause() : play()));
    motionQuery.addEventListener?.('change', () => (motionQuery.matches ? pause() : play()));
    play();
  }

  function prepareFeaturedCarousels() {
    document.querySelectorAll(featuredCarouselSelector).forEach(carousel => { prepareFeaturedCarousel(carousel); prepareAllReviews(carousel); });
  }

  function queueRestore() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      restoreNativeSort();
      prepareProductReviews();
      prepareProductRatingLinks();
      prepareFeaturedCarousels();
    });
  }

  document.addEventListener('DOMContentLoaded', queueRestore, { once: true });
  queueRestore();

  new MutationObserver(queueRestore).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
